import { DatePicker, Form } from 'antd';
import moment from 'moment';
// import 'moment/locale/th';
// moment.locale('th');
export function InputDate({
  name = '',
  label = '',
  type = 'single',
  required = false,
  showTime = false,
  onChange,
  inputProps,
}) {
  return (
    <Form.Item name={name} label={label} rules={[{ required, message: `กรุณาเลือก${label}` }]}>
      {type === 'single' ? (
        <DatePickerComponent
          showTime={showTime}
          style={{ width: '100%' }}
          placeholder={`เลือก${label}`}
          onChange={onChange}
          {...inputProps}
        />
      ) : type === 'range' ? (
        <DateRangePickerComponent
          showTime={showTime}
          style={{ width: '100%' }}
          placeholder={['วันที่เริ่ม', 'วันที่สิ้นสุด']}
          onChange={onChange}
          {...inputProps}
        />
      ) : type === 'year' ? (
        <YearPickerComponent
          style={{ width: '100%' }}
          placeholder={`เลือก${label}`}
          onChange={onChange}
          {...inputProps}
        />
      ) : null}
    </Form.Item>
  );
}

function DatePickerComponent(props) {
  const forceValues = props?.value ? moment(props?.value) : null;

  const thaiYearFormat = (value) => {
    return value.format(`DD MMMM ${value.eraYear() + 543}${props.showTime ? ' HH:mm:ss' : ''}`);
  };

  return <DatePicker {...props} value={forceValues} format={thaiYearFormat} />;
}

function DateRangePickerComponent(props) {
  const forceValues = props?.value ? [moment(props?.value[0]), moment(props?.value[1])] : null;

  const thaiYearFormat = (value) => {
    return value.format(`DD MMMM ${value.eraYear() + 543}${props.showTime ? ' HH:mm:ss' : ''}`);
  };

  return <DatePicker.RangePicker {...props} value={forceValues} format={thaiYearFormat} />;
}

function YearPickerComponent(props) {
  const thaiYearFormat = (value) => value.format(`${value.eraYear() + 543}`);
  return <DatePicker {...props} format={thaiYearFormat} picker="year" />;
}
